import React from 'react';
import Fourzerofour from './404';

async function action () {
    return {
        title: '东楚优房',
        chunks: ['notfound'],
        component: (
            <Fourzerofour />
        )
    };
}
export default action;
